export default "__VITE_ASSET__Y834LnZX__"